import { render, staticRenderFns } from "./StartGameView.vue?vue&type=template&id=677f6133&scoped=true&"
import script from "./StartGameView.vue?vue&type=script&lang=js&"
export * from "./StartGameView.vue?vue&type=script&lang=js&"
import style0 from "./StartGameView.vue?vue&type=style&index=0&id=677f6133&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677f6133",
  null
  
)

export default component.exports